import React from "react";
import { HeroSection } from "../components/HeroSection";
import { LiveResultCard } from "../components/LiveResultCard";
import { FeatureCards } from "../components/FeatureCards";
import { NewsAndUpdatesGrid } from "../components/NewsAndUpdatesGrid";
import { FAQAccordion, DEFAULT_FAQS } from "../components/FAQAccordion";
import { SEOContentSection } from "../components/SEOContentSection";
import { useSEO } from "../hooks/useSEO";
import { SITE_URL } from "../lib/api";

const CONTENT = [
  {
    h: "What is Morning Sunday Teer?",
    p: "Morning Sunday Teer is a morning archery-based number game followed widely across the North East of India. Two rounds are held each day — the First Round (F/R) around 10:30 AM and the Second Round (S/R) around 11:30 AM — and the declared numbers become the day's result.",
  },
  {
    h: "How to check the Morning Sunday Teer result",
    p: "Open this homepage or any dedicated result page and the latest First Round and Second Round numbers appear instantly in the result card. The card refreshes automatically every 60 seconds, so you never have to reload the page to see a newly declared result.",
  },
  {
    h: "Previous results and common numbers",
    p: "Every declared result is automatically saved to our previous-result archive, and a fresh common number is generated for each day. You can explore historical charts and daily common numbers using the feature cards above or the links in the footer.",
  },
  {
    h: "Result timings you should know",
    p: "The morning schedule keeps the First Round close to 10:30 AM and the Second Round close to 11:30 AM (IST). Timings may occasionally vary; this site always reflects the most recent numbers available from the central result data source.",
  },
];

export default function Home() {
  useSEO({
    title: "Morning Sunday Teer | Live Result, Previous Result & Common Number",
    description:
      "Morning Sunday Teer live result today with FR (10:30 AM) and SR (11:30 AM) numbers, previous result charts, daily common numbers and fast updates.",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "Morning Sunday Teer",
        url: SITE_URL + "/",
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Morning Sunday Teer",
        url: SITE_URL + "/",
        description:
          "Informational platform for Morning Sunday Teer live result, previous result and common number.",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: DEFAULT_FAQS.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  });

  return (
    <div>
      <HeroSection />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="-mt-8 sm:-mt-12 relative z-10">
          <LiveResultCard />
        </div>

        <div className="mt-8">
          <FeatureCards />
        </div>

        <div className="mt-14">
          <NewsAndUpdatesGrid />
        </div>

        <div className="mt-14 grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <SEOContentSection heading="Morning Sunday Teer — Fast & Accurate Results" blocks={CONTENT} />
          </div>
          <div className="lg:col-span-1">
            <FAQAccordion />
          </div>
        </div>
      </div>
      <div className="h-8" />
    </div>
  );
}
